import * as React from "react";
import FormWarningsProvider from "contexts/FormWarningsProvider";
import AssetEventForm from "security-app/components/AssetEvents/AssetEventForm";
import EventsSecurityLicenseStatus from "security-app/components/AssetEvents/EventsSecurityLicenseStatus";
const AssetEventFormContainer = (props) => {
  const { eventDefinition, onChange, validation } = props;
  return /* @__PURE__ */ React.createElement(FormWarningsProvider, null, /* @__PURE__ */ React.createElement(EventsSecurityLicenseStatus, null, /* @__PURE__ */ React.createElement(AssetEventForm, { eventDefinition, onChange, validation })));
};
export default AssetEventFormContainer;
